
const abbreviationsObj = window.$feconfig?.abbreviations?.abbreviations
const foreignTermsObj = window.$feconfig?.foreignTerms?.foreignTerms

export default function accessibleTextHandler () {
  return {
    methods: {
      processHTML (buffer, abbreviations = abbreviationsObj, foreignTerms = foreignTermsObj) {
        const html = buffer
        /* TODO: FIX
        let html = buffer
        const templates = {}
        html = html.replace(/<template\b[^>]*>[\s\S]*?<\/template>/gi, match => {
          const key = `__TEMPLATE__${Object.keys(templates).length}__`
          templates[key] = match
          return key
        })

        const titles = {}
        html = html.replace(/<title\b[^>]*>[\s\S]*?<\/title>/gi, match => {
          const key = `__TITLE__${Object.keys(titles).length}__`
          titles[key] = match
          return key
        })

        const scripts = {}
        html = html.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, match => {
          const key = `__SCRIPT__${Object.keys(scripts).length}__`
          scripts[key] = match
          return key
        })

        const tags = {}
        html = html.replace(/<[^>]+>/g, match => {
          const key = `__TAG__${Object.keys(tags).length}__`
          tags[key] = match
          return key
        })

        const abbrs = {}
        for (const abbv of abbreviations) {
          const pattern = new RegExp(`(?:(?<=>)|(?<!\\p{L}))${abbv.term}(?:(?=<)|(?=\\P{L}))`, 'giu')
          const replacement = `<abbr title="${abbv.description}" aria-label="${abbv.description}">$&</abbr>`
          html = html.replace(pattern, replacement)

          html = html.replace(/<abbr\b[^>]*>[\s\S]*?<\/abbr>/gi, match => {
            const key = `__ABBR__${Object.keys(abbrs).length}__`
            abbrs[key] = match
            return key
          })
        }

        const fTerms = {}
        for (const fTerm of foreignTerms) {
          const regex = /<span\b(?=[^>]*\blang\s*=\s*["'][^"']*["'])(?=[^>]*\bclass\s*=\s*["'][^"']*foreign-term[^"']*["'])[^>]*>.*?<\/span>/gis
          const pattern = new RegExp(`(?:(?<=>)|(?<!\\p{L}))${fTerm.term}(?:(?=<)|(?=\\P{L}))`, 'giu')
          const replacement = `<span class="foreign-term" lang="${fTerm.lang}">$&</span>`
          html = html.replace(pattern, replacement)

          html = html.replace(regex, match => {
            const key = `__FTERMS__${Object.keys(fTerms).length}__`
            fTerms[key] = match
            return key
          })
        }

        for (const dict of [abbrs, fTerms, tags, scripts, titles, templates]) {
          for (const key in dict) {
            html = html.replace(key, dict[key])
          }
        }
        */
        return html
      }
    }
  }
}
